import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function Cash() {
  const { network } = useRecoilValue(AccessInfoSelector);

  switch (network) {
    case 'meetme':
      return <div>$</div>;

    case 'lovoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_lv_claim_cash" /></svg>
      );

    case 'vidoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_vidoo_cash" /></svg>
      );

    default:
      return (
        <div>$</div>
      );
  }
}
